import { apiGet, apiPatch } from './client.js';

export interface WaiverSettings {
  preRepair: { content: string; version: string };
  postRepair: { content: string; version: string };
  updatedAt: string;
}

export function getWaivers() {
  return apiGet<WaiverSettings>('/api/v1/waivers').then((res) => res.data);
}

export function updateWaivers(body: { preRepairContent?: string; postRepairContent?: string }) {
  return apiPatch<WaiverSettings, typeof body>('/api/v1/waivers', body).then((res) => res.data);
}
